<template>
  <div
    class="notification_item"
    :class="{ 'notification_item--new': !notification.is_seen }"
    :data-index="index"
    :data-id="notification.id"
  >
    <div class="notification_item-title f18 fw500">{{ notification.title }}</div>
    <div class="notification_item-text f16">{{ notification.body }}</div>
    <div class="notification_item-footer">
      <div>{{ $formatDate(notification.sent_at) }}</div
      ><div>{{ notification.author.first_name + ' ' + notification.author.last_name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNotificationListItem',
  props: {
    notification: Object,
    observer: IntersectionObserver,
    index: Number,
  },
  mounted() {
    this.observer.observe(this.$el)
  },
}
</script>

<style lang="scss" scoped>
.notification_item {
  width: 100%;
  max-width: 500px;
  border: 1px solid #56ccf2;
  // &:not(:first-of-type) {
  //     border-top: 1px solid #d1d1d1;
  // }
  padding: 10px 20px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 10px;
  background: #ffffff;
  border-radius: 10px;
  &-title {
    color: #333333;
  }
  &-text {
    color: #4f4f4f;
    white-space: pre-line;
  }
  &-footer {
    display: flex;
    justify-content: space-between;
    color: #828282;
    flex-wrap: wrap;
  }
  &--new {
    border: 1px solid #6fcf97;
    background: #c9f7d4;
  }
}
</style>
